import { Row } from 'antd';
import styled from 'styled-components';

import CoreButton from 'components/Buttons';

export const Overall = styled.span`
  margin-bottom: 60px;
  line-height: 15px;
  font-size: 12px;
  font-weight: bold;
`;

export const ValidationMessage = styled(Row)`
  display: flex;
  justify-content: flex-end;
  color: #ff4d4f;
`;

export const Button = styled(CoreButton)`
  &:not(:last-of-type) {
    margin-right: 20px;
  }
`;
